module.exports = __webpack_public_path__ + "assets/img/FOF研究中心.4804c014.png";